<template>
  <div class="layout-topbar">
    <router-link to="/" class="layout-topbar-logo">
      <span>Freight Ops V3</span>
    </router-link>

    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      v-styleclass="{
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'animate-scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'animate-fadeout',
        hideOnOutsideClick: true,
      }"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
    <ul class="layout-topbar-menu hidden lg:flex origin-top">
      <li>
        <button class="p-link layout-topbar-button">
          <i class="pi pi-calendar"></i>
          <span>Events</span>
        </button>
      </li>
      <li>
        <button class="p-link layout-topbar-button" @click="onToggleDarkMode">
          <i :class="darkMode ? 'pi pi-sun' : 'pi pi-moon'"></i>
          <span>{{ darkMode ? 'Light Mode' : 'Dark Mode' }}</span>
        </button>
      </li>
      <li>
        <button class="p-link layout-topbar-button" @click="onSettingsClick">
          <i class="pi pi-cog"></i>
          <span>Settings</span>
        </button>
      </li>
      <li>
        <button class="p-link layout-topbar-button" @click="onLogout">
          <i class="pi pi-sign-out"></i>
          <span>Log Out</span>
        </button>
      </li>
    </ul>
  </div>
</template>
  
<script lang="ts">
export default {
  data() {
    return {
      darkMode: localStorage.getItem('darkMode') === 'true',
    };
  },
  mounted() {
    // Sync with appState on mount
    // @ts-ignore
    if (this.$appState?.darkMode !== undefined) {
      // @ts-ignore
      this.darkMode = this.$appState.darkMode;
    }
  },
  methods: {
    onLogout(event) {
      this.$emit("logout", event);
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit("topbar-menu-toggle", event);
    },
    onSettingsClick(event) {
      console.log("AppTopbar onSettingsClick fired", event);
      this.$emit("settings-click", event);
    },
    async onToggleDarkMode(event) {
      event?.preventDefault();
      const newValue = !this.darkMode;
      this.darkMode = newValue;
      
      // Emit event to parent to handle theme toggle
      this.$emit('toggle-dark-mode', newValue);
    },
  },
  computed: {
    darkTheme() {
      // @ts-ignore
      return this.$appState?.theme?.startsWith("saga");
    },
  },
  watch: {
    // Watch appState for external changes (e.g., from AppConfig)
    // @ts-ignore
    '$appState.darkMode'(newValue) {
      if (newValue !== undefined && newValue !== this.darkMode) {
        this.darkMode = newValue;
      }
    },
  },
};
</script>
